var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-card',{attrs:{"title":"Remove favorite","ok-title":"Remove","ok-variant":"danger","cancel-title":"Cancel"},on:{"ok":_vm.save,"cancel":_vm.cancel}},[_c('span',[_vm._v("Are you sure you want to remove this view from favorites?")])])}
var staticRenderFns = []

export { render, staticRenderFns }